import { useEffect, useMemo, useState } from 'react';

/** Assemble contact email only in the browser (not as one plain string in source). */
export function assembleContactEmail() {
  const a = ['e', 'u', 'l', 'b'].reverse().join('');
  const b = ['e', 'u', 'l', 'b'].reverse().join('');
  const c = ['e', 'z', 'i', 'r'].reverse().join('');
  const n = String(234 + 666);
  const at = String.fromCharCode(64);
  const host = ['l', 'i', 'a', 'm', 'g'].reverse().join('');
  const dot = String.fromCharCode(46);
  const tld = ['m', 'o', 'c'].reverse().join('');
  return [a, b, c, n, at, host, dot, tld].join('');
}

export function useContactEmail() {
  const [email, setEmail] = useState('');

  useEffect(() => {
    // Second pass: delay one tick so static scrapers / first paint miss the address
    const id = window.setTimeout(() => {
      setEmail(assembleContactEmail());
    }, 0);
    return () => window.clearTimeout(id);
  }, []);

  return email;
}

/**
 * Renders email as reversed char spans flipped in CSS/JS so HTML source isn't one contiguous address.
 */
export function ObfuscatedEmail({ className, mailto = true, asLink = true }) {
  const email = useContactEmail();
  const glyphs = useMemo(() => {
    if (!email) return [];
    return email.split('').reverse();
  }, [email]);

  if (!email) {
    return <span className={className} aria-hidden="true">…</span>;
  }

  const visual = (
    <span
      className={className}
      style={{ unicodeBidi: 'bidi-override', direction: 'rtl', display: 'inline' }}
      aria-label={email}
    >
      {glyphs.map((ch, i) => (
        <span key={`${i}-${ch}`} style={{ display: 'inline' }}>
          {ch}
        </span>
      ))}
    </span>
  );

  if (!asLink || !mailto) return visual;

  return (
    <a
      href={`mailto:${email}`}
      onClick={(e) => {
        // Rebuild on click in case href was sniffed empty at mount
        e.preventDefault();
        window.location.href = `mailto:${assembleContactEmail()}`;
      }}
    >
      {visual}
    </a>
  );
}

export default ObfuscatedEmail;
